import { api } from '.'
// 获取活动总览信息
export const getAirdropTotal = isLogin => api.get(isLogin ? 'v1/act/airdrop/total/login' : 'v1/act/airdrop/total').json()
// 获取项目状态统计数量
export const getAirdropNum = (isLogin, searchParams) => api.get(isLogin ? 'v1/act/airdrop/num/login' : 'v1/act/airdrop/num', isLogin ? { searchParams } : {}).json()
// 获取项目列表信息
export const getAirdropList = (isLogin, searchParams) => api.get(isLogin ? 'v1/act/airdrop/list/login' : 'v1/act/airdrop/list', { searchParams }).json()
// 用户报名活动
export const airdropUserSignUp = data => api.post('v1/act/airdrop/play', { json: data }).json()
// 获取项目列表信息
export const getAirdropDetail = (isLogin, searchParams) => api.get(isLogin ? 'v1/act/airdrop/single/activity/login' : 'v1/act/airdrop/single/activity', { searchParams }).json()
// 获取用户kyc信息
export const getUserKycInfo = data => api.post('v1/act/kyc/user/info', { json: data, ignoreMessage: 1 }).json()
// 检测钱包下载弹窗
export const airDropCheckShow = () => api.get('v1/act/airdrop/check/show').json()
// 设置不再提醒
export const airDropCloseShow = () => api.get('v1/act/airdrop/close/show').json()
